<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Pasal PPH (With Holding Tax) 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="4">
          <b-input-group >
              <b-input-group-prepend> <span class="pt-2 mr-2">Pasal PPH</span></b-input-group-prepend>
              <b-form-input v-model="tblData.pasalpph" placeholder="WHT Article"></b-form-input>
              <b-form-checkbox v-model="tblData.sifatpph" value="Prepaid" unchecked-value="Payable" switch class="ml-2 pt-2">
                <b> {{ tblData.sifatpph }}</b> Tax
              </b-form-checkbox>
          </b-input-group>
        </b-col>
        <b-col lg="1"> &nbsp;
        </b-col>
        <b-col lg="5">
          <b-input-group >
              <b-input-group-prepend> <span class="pt-2 mr-2">Account</span></b-input-group-prepend>
              <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
              <b-input-group-append> <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
              <b-input-group-append> <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(prepaid)="data">
          <span v-if="(data.item.prepaid==1)">Prepaid</span>
        </template>
        <template v-slot:cell(pph)="data">
          {{ data.item.pph}} %
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
      <div slot="header">Pasal PPH (W/H Tax) - Add/Edit Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
              <b-form-group  label-cols=3  label="Pasal PPH" >
                <b-row>
                   <b-col lg="6">
                      <b-form-input v-model="frmdata.nomorpasal" :state="!$v.frmdata.nomorpasal.$error"></b-form-input>
                   </b-col>
                   <b-col lg="6">
                      <b-input-group >
                          <b-input-group-prepend> <span class="ml-2 pt-2 mr-2"> Tarif PPH </span></b-input-group-prepend>
                          <b-form-input v-model="frmdata.pph" :state="!$v.frmdata.pph.$error" type="number"></b-form-input>
                          <b-input-group-append> <span class="input-group-text"> % </span></b-input-group-append>
                      </b-input-group>
                   </b-col>
                </b-row>
              </b-form-group>
              <b-form-group  label-cols=3  label="Pasal + Tarif" >
                  <b-form-input v-model="frmdata.pasalpph" :state="!$v.frmdata.pasalpph.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="" >
                  <b-form-radio-group  v-model="frmdata.prepaid">
                    <b-form-radio value="1">Prepaid Tax</b-form-radio>
                    <b-form-radio value="0">Payable Tax</b-form-radio>
                    <b-form-radio value="">Prepaid+Payable</b-form-radio>
                  </b-form-radio-group>
              </b-form-group>

              </b-form-group>
              <b-form-group label-cols=3  label="GL Account">
                  <b-input-group >
                      <b-form-input readonly v-model="frmdata.kodeaccInfo" :state="!$v.frmdata.kodeacc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('kodeacc')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
          </b-card>
        </b-col>
    </b-row>

        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import pph from "../../apis/pph";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        nomorpasal: { required },
        pasalpph: { required },
        pph: { required },
        kodeacc: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:true,
      lkuCoaShow:false,
      lkuCoaCaller:'kodeacc',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata: {
          nomorpasal: '',
          pasalpph: '',
          pph: '',
          kodeacc: '',
      },
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sifatpph:this.$route.path.includes("receivable") ? "Prepaid" : "Payable",
        prepaid:'1',
        sortBy: null,
        sortDesc: false,
      },
    };
  },
  components: {lkuCoa},
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "nomorpasal",
            label: "Pasal PPH",
            sortable: true
          },
          {
            key: "pph",
            label: "Tarif PPH",
            sortable: true
          },
          {
            key: "pasalpph",
            label: "Pasal + Tarif",
            sortable: true
          },
          {
            key: "prepaid",
            label: "Prepaid",
            sortable: true
          },
          {
            key: "kodeacc",
            label: "GL Account",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch: {
    "frmdata.nomorpasal": function(newval){
      this.frmdata.pasalpph= `${newval} ${this.frmdata.pph}%`;
    },
    "frmdata.pph": function(newval){
      this.frmdata.pasalpph= `${this.frmdata.nomorpasal} ${newval}%`;
    },
    "tblData.sifatpph": function(newval) {
      setTimeout(() => {
      this.refresh();        
      }, 100);
    }    
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.prepaid = (this.tblData.sifatpph=="Prepaid") ? "1" : "0";

      const list = await pph.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.pph=  '';
        this.tblData.pasalpph=  '';
        this.refresh();
    },
    add: function() {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        this.frmdata.prepaid=0;
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      // this.frmdata.grouplama = data.groupname;
      // this.frmdata.kodelama = data.kodeacc;
      this.frmdata.kodeaccInfo = data.kodeacc;
      this.frmdata.ppaidaccInfo = data.ppaidacc;
      let _selected;
      try {
        if (data.kodeacc) {
          _selected = await pph.findcoa({kodeacc: data.kodeacc, tahun: this.tahun});
          this.frmdata.kodeaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        }
        if (data.ppaidacc) {
          _selected = await pph.findcoa({kodeacc: data.ppaidacc, tahun: this.tahun});
          this.frmdata.ppaidaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        }
      } catch (error) {
        if (error.message) {
            toastr.error(error.message);
        } else {
            toastr.error(JSON.stringify(error));
        }                      
      }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await pph.save(this.frmdata);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await pph.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[this.lkuCoaCaller] = _selected.kodeacc;
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
